export default __webpack_public_path__ + "envelope.png";